<template>
  <div class="card" id="orderLinkNextStepsCard">
      <div class="card-header mt-3">
          <h5 class="card-title text-center">OrderLink: Further Action Needed</h5>
          <hr>
      </div>
      <div class="card-body">
          <div class="row message">
						<div>
							For this order to be processed completely, you must fill in the form on the page at this link:
						</div>
						<div style="margin: 25px auto; ">
							<span class="worksheet_link" @click="worksheetClick">Order Intake Form</span>
						</div>
					</div>
			</div>
	</div>
</template>

<script>
  export default {
    name: "OrderLinkNextStepsDialog",
    props: {
        url: {
            type: String,
            default: ''
        }
    },
    data: () => {
        return {}
		},
    methods: {
      worksheetClick() {
        window.open(this.url, "", "width=800, height=600");
      }
    }
	}
</script>

<style scoped lang="scss">
  .card {
      min-width: 300px;
      max-width: 600px;
      width: 400px;
      height: 300px;
  }

  #orderLinkNextStepsCard {
      width: 525px;
      height: 300px;
			//margin-top: -28px;
  }

	.card-title {
		font-size: 18pt;
	}

  .col-4 {
      z-index: 99;
  }

	.message {
		padding: 5px 20px;
    font-size: 16pt;
    text-align: center;
	}

  .worksheet_link {
    font-weight: 600;
    text-decoration: underline;
    cursor: pointer;
    margin-top: 25px;
  }

</style>
